import { navigate } from "gatsby"

// ** Custom Components
import Box from "../../../components/Box"
import Container from "../../../components/Container"
import Text from "../../../components/Text"
import { acn_i18n } from "../../../data/i18n_constants"

function Footer({ lang, lrp }: { lang: string; lrp?: boolean }) {
  const isFr = lang === "fr_CA"

  const logoLink = isFr ? "/8Twelve_Mortgage_fr.svg" : "/8Twelve_Mortgage.svg"

  const brokerageLicensesNumbere = isFr
    ? [
        "Ont. licence n° 13072",
        "Alb. licence n° 2122265990",
        "C.-B. licence n° X300983",
        "Man. licence n° RW-2011175",
        "T.-N.-L. licence n° 88786",
        "N.-B. licence n° 21004252",
        "N.-É. licence n° 4342039",
        "Î.-P.-É. licence n° 755902715",
        "Qc licence n° 606914",
        "Sask. licence n° 508695",
        "Yn licence n° 839770",
      ]
    : [
        "ON License #13072",
        "AB License #2122265990",
        "BC License #X300983",
        "MB License #RW-2011175",
        "NL License #88786",
        "NB License #21004252",
        "NS License #4342039",
        "PEI License #755902715",
        "QC License #606914",
        "SK License #508695",
        "YT License #839770",
      ]

  return (
    <Box className="mt-16 lg:mt-32">
      <Container constrainedToBreakPoint className="px-4 mb-4">
        <div className="ml-3 text-sm leading-6 text-center">
          {lrp ? (
            <></>
          ) : (
            <>
              {" "}
              <span>
                {acn_i18n.terms_one[lang]}{" "}
                <a href="/privacy-policy" className="underline" target="_black">
                  {acn_i18n.terms_two[lang]}
                </a>{" "}
                {acn_i18n.terms_three[lang]}
              </span>
            </>
          )}
        </div>
      </Container>
      <Box
        as="footer"
        className="pt-16 lg:pt-20  bg-[#B9B8BC] bg-opacity-20 pb-6 lg:pb-16"
      >
        <Container constrainedToBreakPoint className="px-4">
          <Box className="flex flex-col items-center justify-center gap-4 mb-16 md:gap-20 md:flex-row ">
            <Box className="mb-[50px] ">
              <img
                className="w-[190px] cursor-pointer"
                src={logoLink}
                alt="8Twelve Mortgage"
                aria-label="8Twelve Mortgage"
                onClick={() => navigate("/")}
              />
            </Box>
            <Box className="mb-10">
              <Box className="flex flex-col items-start md:items-start">
                <Text className="font-bold mb-2 !text-sm">
                  8Twelve Mortgage Corp.
                </Text>
              </Box>
              <Box className="flex flex-col items-start !text-sm font-bold pb-2">
                <Box>{acn_i18n.brokerage_license[lang]}</Box>
              </Box>
              <Box className="grid grid-cols-1 gap-x-4 gap-y-2 md:grid-cols-4">
                {brokerageLicensesNumbere.map((item) => (
                  <Box className=" md:text-left font-normal text-gray-700 !text-sm">
                    {item}
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>

          <Box
            as="div"
            className="border-b-[0.25px] border-gray-700 mt-6 lg:mt-16"
          />
          <Box className="flex justify-center pt-2">
            <Box className="text-sm text-gray-700">
              {acn_i18n.all_rights_reserved[lang]}
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  )
}

export default Footer
